import {
  appendVisitorHandoffParams,
  parseUtmParamsFromSearch,
  type ClickIds,
} from "@repo/analytics";

import { webAnalyticsSession } from "@/lib/briefpanel-analytics-storage";

/**
 * Fold the visitor id, the landing click ids (gclid/gbraid/wbraid) and the UTM
 * params of the current page into an app.briefpanel.com href, so the app opens
 * attributed to the campaign that brought the visitor (issue #275).
 *
 * Attribution is best-effort: storage can throw (private mode, quota), and the
 * handoff must still happen, so a failure only drops the ids — the href keeps
 * the UTM params and the caller navigates as usual.
 */
export async function resolveAppHandoffHref(target: string): Promise<string> {
  const search = typeof window === "undefined" ? "" : window.location.search;
  let visitorId: string | null = null;
  let clickIds: ClickIds | null = null;
  try {
    await webAnalyticsSession.captureClickIds(search);
    [visitorId, clickIds] = await Promise.all([
      webAnalyticsSession.resolveVisitorId(search),
      webAnalyticsSession.getFreshClickIds(),
    ]);
  } catch {
    // Attribution is best-effort; the handoff proceeds without the ids.
  }
  return appendVisitorHandoffParams(
    target,
    { visitorId, clickIds, utm: parseUtmParamsFromSearch(search) },
    { webAppUrl: process.env.NEXT_PUBLIC_APP_URL },
  );
}
